import React from "react";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useLocation, useNavigate } from "react-router-dom";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { BarChart } from "@mui/x-charts/BarChart";
import { cheerfulFiestaPalette } from "@mui/x-charts/colorPalettes";
import { pieArcLabelClasses, PieChart } from "@mui/x-charts/PieChart";

import { ButtonSendTheme } from "@/styles/mui/tableListTheme";
// Components
import { ShopSelection } from "@/components/Filter/shopSelection";
import Layout from "@/components/layout";
import ShopSalesExportPopup from "@/components/shopSalesExportPopup";
import Title from "@/components/title";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

// Fetch
import {
  getProductSalesByShopCode,
  getShopSalesByAreaMan,
  getShopSalesByMonth,
  getShopSalesWithTarget,
} from "@/fetch/fetchStatistics";

import { getRegionOptions } from "@/fetch/fetchWork";
// Moment
import { useCurrentAction } from "@/hooks/user";
import getDateRange from "@/lib/getDateRange";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";
const ShopSalesChartPage = (props) => {
  const actions = useCurrentAction();
  const { open, setOpen } = props;
  const location = useLocation();
  const navigate = useNavigate();

  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  const colorCode = {
    Childlife: "41,77,29",
    Cleverin: "46,143,191",
    theGlobalab: "218,49,42",
    Holdbody: "236,43,141",
    Jintan: "255,237,2",
    Mycosan: "132,98,210",
    Proteca: "254,78,2",
    Return: "0,0,0",
    ShaoYeh: "255,188,46",
    Proven: "180,152,92",
    Others: "82,117,134,",
  };
  // Navigate
  const [amOptions, setAmOptions] = React.useState([]);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState(null);
  const [isWholeMonth, setIsWholeMonth] = React.useState(false);
  const [allOptions, setAllOptions] = React.useState([]);
  const [shopOptions, setShopOptions] = React.useState([]);
  const [districtOptions, setDistrictOptions] = React.useState([]);
  const [areaOptions, setAreaOptions] = React.useState([]);
  const [filterAreaOptions, setFilterAreaOptions] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [showChart, setShowChart] = React.useState(false);
  const [expanded, setExpanded] = React.useState(true);
  const [leftAxis, setLeftAxis] = React.useState("DEFAULT_Y_AXIS_KEY");
  const [showAmount, setShowAmount] = React.useState(
    location.state?.showAmount ?? false,
  );
  const [manningsData, setManningsData] = React.useState(false);
  const [selectedShop, setSelectShop] = React.useState(null);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const [groupBy, setGroupBy] = React.useState("am");
  const [limit, setLimit] = React.useState(location.state?.limit ?? 0);
  const [orderBy, setOrderBy] = React.useState(
    location.state?.orderBy ?? "percent",
  );
  const [ordering, setOrdering] = React.useState(
    location.state?.ordering ?? "DESC",
  );
  const [mode, setMode] = React.useState(
    location.state?.mode ?? "amPerformance",
  );
  const [pieBrandData, setPieBrandData] = React.useState([]);
  const [pieProductData, setPieProductData] = React.useState([]);
  const [optionReady, setOptionReady] = React.useState(false);
  const [pieTotal, setPieTotal] = React.useState(0);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [chartData, setChartData] = React.useState({
    series: [],
    xAxis: [],
    height: 600,
    highlightScope: {
      additionalRadius: 10,
      faded: "global",
    },
  });
  const [currentFilter, setCurrentFilter] = React.useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    district: [],
    am: [],
    area: [],
    shop: [],
  });
  const [filter, setFilter] = React.useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    district: [],
    am: [],
    area: [],
    shop: [],
  });
  const handleShopFilterChange = (value) => {
    setFilter((prev) => {
      return {
        ...prev,
        shop: value,
      };
    });
  };
  const handleShopAxisClick = async (start_date, end_date, mode) => {
    const shopCode = selectedShop.split("-")[0];
    const { data: sales } = await getProductSalesByShopCode(
      shopCode.trim(),
      moment(start_date).format("YYYY-MM-DD"),
      moment(end_date).format("YYYY-MM-DD"),
      manningsData,
    );
    const brandDatas = [];
    const productDatas = [];

    const groupByBrands = _.groupBy(sales, "brand_types_name");
    _.forEach(groupByBrands, (groupByBrand, key) => {
      const sum = _.sumBy(groupByBrand, (u) => {
        return u.total ? parseFloat(u.total) : 0;
      });
      brandDatas.push({
        id: key,
        value: sum,
        label: key,
        brandName: key,
        color: `rgba(${colorCode[key]},1)`,
      });
      const groupByM18s = _.groupBy(groupByBrand, "m18_product_code");
      _.forEach(groupByM18s, (groupByM18, index) => {
        productDatas.push({
          id: groupByM18[0].m18_product_code,
          brand: key,
          value: _.sumBy(groupByM18, (product) => parseInt(product.total)),
          label: groupByM18[0].product_name,
          color: `rgba(${colorCode[groupByM18[0].brand_types_name]},0.${(
            Math.random() * (999 - 500) +
            500
          ).toFixed()})`,
        });
      });
    });
    const total = brandDatas
      .map((item) => item.value)
      .reduce((a, b) => a + b, 0);
    const removed = _.remove(productDatas, (productData) => {
      return (productData.value / total) * 100 < 3;
    });
    const groupRemovedByBrands = _.groupBy(removed, "brand");
    _.forEach(groupRemovedByBrands, (groupRemovedByBrand, brand) => {
      productDatas.push({
        id: `${brand}-others`,
        brand: brand,
        value: _.sumBy(groupRemovedByBrand, (product) =>
          parseInt(product.value),
        ),
        label: "Others",
        color: `rgba(${colorCode[brand]},0.${(
          Math.random() * (999 - 500) +
          500
        ).toFixed()})`,
      });
    });
    setPieTotal(total);
    setPieBrandData(_.orderBy(brandDatas, ["id"], ["asc"]));
    setPieProductData(_.orderBy(productDatas, ["brand"], ["asc"]));
    setMode(mode);
  };
  const handlePieClick = async (brand) => {
    let start_date = "";
    let end_date = "";
    if (selectedDate) {
      start_date = moment(selectedDate).format("YYYY-MM-DD");
      end_date = moment(selectedDate).format("YYYY-MM-DD");
    } else {
      start_date = moment(filter.startDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      end_date = moment(filter.startDate).endOf("month").format("YYYY-MM-DD");
    }
    const shopCode = selectedShop.split("-")[0];

    const { data: sales } = await getProductSalesByShopCode(
      shopCode.trim(),
      start_date,
      end_date,
      manningsData,
    );
    const data = [];

    const groupByCodes = _.groupBy(
      _.filter(sales, (sale) => sale.brand_types_name === brand),
      "m18_product_code",
    );
    _.forEach(groupByCodes, (groupByCode, key) => {
      const sum = _.sumBy(groupByCode, (code) => {
        return parseInt(code.total);
      });

      data.push({ id: key, value: sum, label: groupByCode[0].product_name });
    });
    setPieTotal(data.map((item) => item.value).reduce((a, b) => a + b, 0));
    setPieProductData(data);
    setMode("product");
  };
  const handleAxisClick = async (shop) => {
    setSelectShop(shop);
    const shopCode = shop.split("-")[0];
    const { data: sales } = await getShopSalesByMonth(
      shopCode.trim(),
      moment(filter.startDate).format("YYYY-MM"),
      manningsData,
    );
    setMode("shop");

    let xAxis = [
      {
        data: [],
        scaleType: "band",
        id: "axis1",
        valueFormatter: (value, context) =>
          `${moment(value).format(`DD/MM`)}\n${moment(value).format(`dddd`)}`,
      },
    ];
    const seriesData = {
      id: "sales-amount",
      data: [],
      label: `銷售(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    const series = [];
    let labels = getDateRange(filter.startDate, filter.endDate);
    xAxis[0].data = labels;
    _.forEach(labels, (label) => {
      const foundSales = sales.find(
        (sale) => sale.tx_date === moment(label).format("YYYY-MM-DD"),
      );
      if (foundSales === undefined || !foundSales.total) {
        seriesData.data.push(0);
      } else {
        seriesData.data.push(parseFloat(foundSales.total));
      }
    });
    series.push(seriesData);

    setLeftAxis("DEFAULT_Y_AXIS_KEY");
    setChartData({
      series,
      xAxis,
      height: 500,
    });
  };

  const fetchAmPerformance = async (selectedFilter = filter) => {
    const { data } = await getShopSalesByAreaMan(selectedFilter, manningsData);
    let xAxis = [
      {
        data: [],
        scaleType: "band",
        id: "axis1",
        labelStyle: {
          transform: "translateY(30px)",
        },
      },
    ];
    const series = [];
    let labels = _.map(data, "full_name");
    setLoading(false);
    setMode("amPerformance");
    xAxis[0].data = labels;
    const seriesData = {
      id: "sales-amount",
      data: _.map(data, "sales_total"),
      label: `銷售(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    const seriesManningsData = {
      id: "mannings-sales-amount",
      data: _.map(data, "mannings_sales_total"),
      label: `萬寧銷售(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    const seriesTargetData = {
      id: "target-amount",
      data: _.map(data, "target_total_amount"),
      label: `目標金額(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    series.push(seriesData);
    series.push(seriesManningsData);
    series.push(seriesTargetData);

    setChartData({
      series,
      xAxis,
      height: 500,
    });
    setShowChart(true);
    setExpanded(false);
  };
  const fetchShopSales = async (selectedFilter = filter) => {
    const { data: sales } = await getShopSalesWithTarget(
      selectedFilter,
      orderBy,
      ordering,
      limit,
      manningsData,
    );
    let xAxis = [
      {
        data: [],
        scaleType: "band",
        id: "axis1",
        labelStyle: {
          // Move the x-axis label with style
          transform: "translateY(30px)",
        },
        valueFormatter: (value, context) => value.split("").join("\n"),
      },
    ];
    const series = [];
    let labels = _.map(
      _.uniqBy(sales, "work_name"),
      (s) => `${s.work_shortcode} - ${s.work_name}`,
    );
    setLoading(false);
    setMode("all");
    xAxis[0].data = labels;
    const seriesData = {
      id: "sales-amount",
      data: [],
      label: `銷售(${showAmount ? "HKD" : "%"})`,
      stack: "total",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) =>
        showAmount ? `$${new Intl.NumberFormat().format(value)}` : `${value}%`,
    };
    const seriesAmountData = {
      id: "sales-amount",
      data: [],
      label: `銷售`,
      stack: "total",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    const seriesTargetAmountData = {
      id: "sales-target-amount",
      data: [],
      label: `目標`,
      stack: "total",
      color: "#FF5733",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };
    const seriesRemainTargetData = {
      id: "target-ramain",
      data: [],
      label: "當前銷售(HKD)",
      stack: "total",
      color: "#FF5733",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) =>
        showAmount ? `$${new Intl.NumberFormat().format(value)}` : `${value}%`,
    };
    const seriesOffTargetData = {
      id: "target-off",
      data: [],
      label: "低於目標(％)",
      stack: "total",
      color: "#FF0000",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `${value}%`,
    };
    const seriesOverTargetData = {
      id: "target-over",
      data: [],
      label: "高於目標(％)",
      stack: "total",
      color: "#FFE633",
      highlightScope: {
        highlighted: "item",
      },
      valueFormatter: (value) => `${value}%`,
    };
    _.forEach(labels, (label) => {
      const foundSales = sales.find(
        (sale) => `${sale.work_shortcode} - ${sale.work_name}` === label,
      );
      if (foundSales === undefined) {
        seriesData.data.push(0);
        seriesRemainTargetData.data.push(0);
      } else {
        const sum = parseFloat(
          manningsData
            ? (foundSales.actual_amount ?? 0)
            : (foundSales.total ?? 0),
        );
        const target = parseInt(foundSales.target_total_amount ?? 0);
        if (!showAmount) {
          const percent = manningsData
            ? foundSales.actual_percent
            : foundSales.percent;
          if (parseFloat(percent) > 1) {
            seriesData.data.push(100);
            seriesOverTargetData.data.push(
              Math.round((parseFloat(percent ?? 0) * 100 - 100) * 100) / 100,
            );
            seriesOffTargetData.data.push(0);
          } else {
            seriesData.data.push(
              Math.round(parseFloat(percent ?? 0) * 100 * 100) / 100,
            );
            seriesOverTargetData.data.push(0);
            seriesOffTargetData.data.push(
              Math.round(
                (100 - Math.round(parseFloat(percent ?? 0) * 100 * 100) / 100) *
                  100,
              ) / 100,
            );
          }
        } else {
          if (sum > target) {
            seriesTargetAmountData.data.push(target);
            seriesAmountData.data.push(sum);
          } else {
            seriesTargetAmountData.data.push(target);
            seriesAmountData.data.push(sum);
          }
          seriesTargetAmountData.valueFormatter = (value, { dataIndex }) => {
            return `$${new Intl.NumberFormat().format(value)}`;
          };
          seriesData.data.push(sum);
        }
        seriesRemainTargetData.data.push(target);
      }
    });
    if (showAmount) {
      series.push({ ...seriesAmountData });
      series.push({ ...seriesTargetAmountData });
    } else {
      series.push(seriesData);
      series.push(seriesOverTargetData);
      series.push(seriesOffTargetData);
    }
    setChartData({
      series,
      xAxis,
      height: 500,
    });
    setLeftAxis("DEFAULT_Y_AXIS_KEY");
    setShowChart(true);
    setExpanded(false);
    //console.log("xAxis", xAxis);
  };
  const handleAMChange = (e) => {
    const filterOptions = _.filter(allOptions, (allOption) =>
      e.target.value.includes(allOption.user_id),
    );
    const filterDistrict = _.uniqBy(
      _.map(
        filterOptions.filter((option) =>
          e.target.value.includes(option.user_id),
        ),
        "district_id",
      ),
    );
    const filterArea = areaOptions.filter((areaOption) =>
      filterDistrict.includes(areaOption.district_id),
    );
    setFilter((prev) => {
      return {
        ...prev,
        am: e.target.value,
        district: filterDistrict,
        area: _.map(filterArea, "area_id"),
        shop: _.map(filterOptions, "shop_id"),
      };
    });
    setFilterAreaOptions(filterArea);
    setShopOptions(filterOptions);
  };
  const handleDistricthange = (e) => {
    const filterShops = _.filter(shopOptions, (shopOption) =>
      e.target.value.includes(shopOption.district_id),
    );
    setShopOptions(filterShops);
    if (e.target.value.includes("ALL")) {
      const allDistrictOptions = _.map(districtOptions, "district_id");
      setFilter((prev) => {
        return {
          ...prev,
          district:
            allDistrictOptions.length === e.target.value.length - 1
              ? []
              : allDistrictOptions,
          area: _.map(areaOptions, "area_id"),
          shop: _.map(filterShops, "shop_id"),
        };
      });
      setFilterAreaOptions(areaOptions);
    } else {
      const filterArea = areaOptions.filter((areaOption) =>
        e.target.value.includes(areaOption.district_id),
      );
      setFilter((prev) => {
        return {
          ...prev,
          district: e.target.value,
          area: _.map(filterArea, (a) => a.area_id),
          shop: _.map(filterShops, "shop_id"),
        };
      });
      setFilterAreaOptions(filterArea);
    }
  };
  const handleAreaChange = (e) => {
    const filterShops = _.filter(allOptions, (shopOption) =>
      e.target.value.includes(shopOption.area_id),
    );
    setShopOptions(filterShops);

    if (e.target.value.includes("ALL")) {
      setFilter((prev) => {
        return {
          ...prev,
          area:
            filterAreaOptions.length === e.target.value.length - 1
              ? []
              : _.map(filterAreaOptions, (a) => a.area_id),
          shop: _.map(filterShops, "shop_id"),
        };
      });
    } else {
      setFilter((prev) => {
        return {
          ...prev,
          area: e.target.value,
          shop: _.map(filterShops, "shop_id"),
        };
      });
    }
  };
  const getArcLabel = (params) => {
    const percent = params.value / pieTotal;
    return `${(percent * 100).toFixed(0)}%`;
  };
  //Fetch all
  const fetchAll = async (fetchAm = false) => {
    const { data: workOptions } = await getRegionOptions();
    setShopOptions(workOptions);
    setAllOptions(workOptions);
    const areaManOptions = _.map(
      _.uniqBy(workOptions, "user_id"),
      (option) => ({
        am_id: option.user_id,
        am_name: option.full_name,
      }),
    );
    const areasOptions = _.map(_.uniqBy(workOptions, "area_id"), (option) => ({
      area_id: option.area_id,
      area_name: option.area_name,
      district_id: option.district_id,
    }));
    const district = _.map(_.uniqBy(workOptions, "district_id"), (option) => ({
      am_id: option.user_id,
      district_id: option.district_id,
      district_name: option.district_name,
    }));
    setDistrictOptions(district);
    setAmOptions(areaManOptions);
    const updateFilter = {
      ...filter,
      district: _.map(district, "district_id"),
      am: _.map(areaManOptions, "am_id"),
      area: _.map(areasOptions, "area_id"),
      shop: _.map(workOptions, "shop_id"),
    };
    setFilter(updateFilter);

    setAreaOptions(areasOptions);
    setFilterAreaOptions(areasOptions);
    if (fetchAm) {
      await fetchAmPerformance(updateFilter);
    }
    setOptionReady(true);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (optionReady) {
      switch (mode) {
        case "amPerformance":
          fetchAmPerformance();
          break;
        case "all":
          fetchShopSales();
          break;
        case "shop":
          handleAxisClick(selectedShop);
          break;
        case "brand":
          if (selectedDate) {
            handleShopAxisClick(selectedDate, selectedDate, "brand");
          } else {
            handleShopAxisClick(
              moment(filter.startDate).startOf("month").format("YYYY-MM-DD"),
              moment(filter.startDate).endOf("month").format("YYYY-MM-DD"),
              "brand",
            );
          }
          break;
        case "product":
          handlePieClick(selectedBrand);
          break;
        default:
          break;
      }
      navigate(location.pathname, { replace: true });
    }
  }, [showAmount, limit, ordering, manningsData, orderBy, optionReady]);
  return (
    <Layout
      header="DailyPage"
      selectedIndex={34}
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      key="1"
    >
      <Title
        title="店鋪銷售統計"
        children={
          <div>
            {actions?.download && (
              <IconButton component="label">
                <ShopSalesExportPopup
                  setSnackMessage={setSnackMessage}
                  setSnackOpen={setSnackOpen}
                  setSnackSeverity={setSnackSeverity}
                  {...{
                    ...props,
                  }}
                />
              </IconButton>
            )}
          </div>
        }
      />
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={expanded}
          style={{ flexGrow: 1, display: "block" }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => setExpanded(!expanded)}
              ></ExpandMoreIcon>
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SearchIcon></SearchIcon>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2,
                }}
              >
                <FormControl fullWidth>
                  <DatePicker
                    disableFuture
                    views={["year", "month"]}
                    label="選擇月份"
                    value={filter.startDate}
                    onChange={(newValue) => {
                      setFilter((prev) => {
                        return {
                          ...prev,
                          startDate: moment(newValue)
                            .startOf("month")
                            .format("YYYY-MM-DD"),
                          endDate: moment(newValue)
                            .endOf("month")
                            .format("YYYY-MM-DD"),
                        };
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "100%" }} />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="am-select-label">AM</InputLabel>
                  <Select
                    labelId="am-select-label"
                    id="am-select"
                    value={filter.am}
                    label="am"
                    multiple
                    onChange={handleAMChange}
                    renderValue={(selected) =>
                      selected.length === amOptions.length
                        ? "所有AM"
                        : `已選擇${selected.length}個`
                    }
                    input={<OutlinedInput label="AM" />}
                  >
                    {_.map(amOptions, (item, index) => (
                      <MenuItem key={index} value={item.am_id}>
                        <Checkbox
                          checked={
                            filter.am.find((d) => d === item.am_id) !==
                            undefined
                          }
                        />
                        <ListItemText primary={item.am_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="district-select-label">地區</InputLabel>
                  <Select
                    labelId="district-select-label"
                    id="district-select"
                    value={filter.district}
                    label="district"
                    multiple
                    onChange={handleDistricthange}
                    renderValue={(selected) =>
                      selected.length === districtOptions.length
                        ? "所有地區"
                        : `已選擇${selected.length}個`
                    }
                    input={<OutlinedInput label="地區" />}
                  >
                    <MenuItem key={"ALL"} value={"ALL"}>
                      <Checkbox
                        checked={
                          filter.district.length === districtOptions.length
                        }
                      />
                      <ListItemText primary={"所有地區"} />
                    </MenuItem>
                    {_.map(districtOptions, (item, index) => (
                      <MenuItem key={index} value={item.district_id}>
                        <Checkbox
                          checked={
                            filter.district.find(
                              (d) => d === item.district_id,
                            ) !== undefined
                          }
                        />
                        <ListItemText primary={item.district_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="area-select-label">區域</InputLabel>
                  <Select
                    labelId="area-select-label"
                    id="area-select"
                    value={filter.area}
                    multiple
                    label="area"
                    onChange={handleAreaChange}
                    renderValue={(selected) =>
                      selected.length === filterAreaOptions.length
                        ? "所有區域"
                        : `已選擇${selected.length}個`
                    }
                    input={<OutlinedInput label="區域" />}
                  >
                    <MenuItem key={"ALL"} value={"ALL"}>
                      <Checkbox
                        checked={
                          filter.area.length === filterAreaOptions.length
                        }
                      />
                      <ListItemText primary={"所有區域"} />
                    </MenuItem>
                    {_.map(filterAreaOptions, (item, index) => (
                      <MenuItem key={index} value={item.area_id}>
                        <Checkbox
                          checked={
                            filter.area.find((d) => d === item.area_id) !==
                            undefined
                          }
                        />
                        <ListItemText primary={item.area_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2,
                }}
              >
                <ShopSelection
                  filter={filter}
                  handleShopFilterChange={handleShopFilterChange}
                  shopOptions={shopOptions}
                ></ShopSelection>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 1,
                  lg: 1,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="grouping-select-label">分類</InputLabel>
                  <Select
                    labelId="grouping-select-label"
                    id="grouping-select"
                    value={groupBy}
                    label="grouping"
                    onChange={(e) => {
                      setGroupBy(e.target.value);
                    }}
                  >
                    <MenuItem value={"am"}>AM</MenuItem>
                    <MenuItem value={"shop"}>店鋪</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 1,
                  lg: 1,
                }}
              >
                <ThemeProvider theme={ButtonSendTheme}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <LoadingButton
                      size="small"
                      onClick={async () => {
                        setLoading(true);
                        setCurrentFilter(filter);
                        switch (mode) {
                          case "amPerformance":
                          case "all":
                            if (groupBy === "am") {
                              fetchAmPerformance();
                            } else {
                              fetchShopSales();
                            }
                            break;
                          case "shop":
                            handleAxisClick(selectedShop);
                            break;
                          case "brand":
                            if (isWholeMonth) {
                              handleShopAxisClick(
                                moment(filter.startDate)
                                  .startOf("month")
                                  .format("YYYY-MM-DD"),
                                moment(filter.startDate)
                                  .endOf("month")
                                  .format("YYYY-MM-DD"),
                                "brand",
                              );
                            } else {
                              handleShopAxisClick(
                                selectedDate,
                                selectedDate,
                                "brand",
                              );
                              handleAxisClick(selectedShop);
                            }
                            break;
                          case "product":
                            if (isWholeMonth) {
                              handlePieClick(selectedBrand);
                            } else {
                              handleShopAxisClick(
                                selectedDate,
                                selectedDate,
                                "brand",
                              );
                              handleAxisClick(selectedShop);
                            }
                            break;
                          default:
                            break;
                        }
                        setLoading(false);
                      }}
                      disabled={
                        filter.am.length <= 0 ||
                        filter.area.length <= 0 ||
                        filter.district.length <= 0
                      }
                      endIcon={<SearchOutlinedIcon fontSize="small" />}
                      loading={isLoading}
                      loadingPosition="end"
                      variant="contained"
                    >
                      搜尋
                    </LoadingButton>
                  </div>
                </ThemeProvider>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      {showChart && (
        <Fade in={true} mountOnEnter unmountOnExit>
          <StyledPaper page={"yes"} alignItems={"left"}>
            <ThemeProvider theme={TableListTheme}></ThemeProvider>
            <Grid container spacing={2} size={12} justifyContent="flex-start">
              {mode === "all" && (
                <React.Fragment>
                  <Grid
                    size={{
                      xs: 12,
                      md: 2,
                      lg: 2,
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="orderBy-select-label">
                        排序方法
                      </InputLabel>
                      <Select
                        labelId="orderBy-select-label"
                        id="orderBy-select"
                        value={orderBy}
                        label="orderBy"
                        onChange={(e) => {
                          setOrderBy(e.target.value);
                        }}
                      >
                        <MenuItem value={"percent"}>比例</MenuItem>
                        <MenuItem value={"amount"}>金額</MenuItem>
                        <MenuItem value={"target"}>目標</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 2,
                      lg: 2,
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="sorting-select-label">排序</InputLabel>
                      <Select
                        labelId="sorting-select-label"
                        id="sorting-select"
                        value={ordering}
                        label="ordering"
                        onChange={(e) => {
                          setOrdering(e.target.value);
                        }}
                      >
                        <MenuItem value={"DESC"}>高至低</MenuItem>
                        <MenuItem value={"ASC"}>低至高</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 2,
                      lg: 2,
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="limit-select-label">顯示數量</InputLabel>
                      <Select
                        labelId="limit-select-label"
                        id="limit-select"
                        value={limit}
                        label="limit"
                        onChange={(e) => {
                          setLimit(e.target.value);
                        }}
                      >
                        <MenuItem value={0}>全部</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={30}>30</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 2,
                      lg: 2,
                    }}
                    alignContent={"center"}
                  >
                    <FormControlLabel
                      checked={showAmount}
                      control={
                        <Checkbox
                          onChange={(event) =>
                            setShowAmount(event.target.checked)
                          }
                        />
                      }
                      label="顯示實際金額"
                      labelPlacement="start"
                    />
                  </Grid>
                </React.Fragment>
              )}
              {mode !== "amPerformance" && (
                <Grid size="grow" alignContent={"center"}>
                  <FormControlLabel
                    checked={manningsData}
                    control={
                      <Checkbox
                        onChange={(event) =>
                          setManningsData(event.target.checked)
                        }
                      />
                    }
                    label="萬寧數據"
                    labelPlacement="start"
                  />
                </Grid>
              )}
              {mode !== "amPerformance" && (
                <Grid
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 1,
                  }}
                  offset={1}
                  alignContent={"center"}
                >
                  <Button
                    variant="contained"
                    onClick={async () => {
                      switch (mode) {
                        case "all":
                          setSelectShop(null);
                          await fetchAll(true);
                          break;
                        case "shop":
                          setSelectShop(null);
                          await fetchShopSales();
                          break;
                        case "brand":
                          setSelectedDate(null);
                          handleAxisClick(selectedShop);
                          break;
                        case "product":
                          if (selectedDate) {
                            handleShopAxisClick(
                              selectedDate,
                              selectedDate,
                              "brand",
                            );
                          } else {
                            handleShopAxisClick(
                              moment(filter.startDate)
                                .startOf("month")
                                .format("YYYY-MM-DD"),
                              moment(filter.startDate)
                                .endOf("month")
                                .format("YYYY-MM-DD"),
                              "brand",
                            );
                          }
                          break;
                        default:
                          break;
                      }
                    }}
                  >
                    <ArrowBackIosIcon></ArrowBackIosIcon>返回
                  </Button>
                </Grid>
              )}
            </Grid>

            <Stack
              direction={{ xs: "row", md: "row" }}
              sx={{ width: "100%", justifyContent: "center" }}
            >
              <Grid container>
                {mode === "shop" ? (
                  <Button
                    onClick={() => {
                      setIsWholeMonth(true);
                      handleShopAxisClick(
                        moment(filter.startDate).startOf("month"),
                        moment(filter.startDate).endOf("month"),
                        "brand",
                      );
                    }}
                  >
                    {selectedShop}(
                    {moment(currentFilter.startDate).format("YYYY年M月")})
                  </Button>
                ) : selectedDate ? (
                  <>
                    {selectedShop}({moment(selectedDate).format("YYYY年M月D號")}
                    )
                  </>
                ) : (
                  <>
                    {selectedShop}(
                    {moment(currentFilter.startDate).format("YYYY年M月")})
                  </>
                )}
              </Grid>
            </Stack>
            <Stack
              direction={{ xs: "column", md: "row" }}
              textAlign="center"
              sx={{ width: "100%" }}
            >
              <Box
                sx={{ flexGrow: 1, mt: 1 }}
                justifyContent="center"
                alignItems="center"
                display="flex"
              >
                {mode === "brand" ? (
                  <PieChart
                    slotProps={{
                      legend: {
                        hidden: true,
                      },
                    }}
                    margin={{ right: 5 }}
                    series={[
                      {
                        innerRadius: 0,
                        outerRadius: 150,
                        arcLabelMinAngle: 10,
                        data: pieBrandData,
                        valueFormatter: (value) => {
                          return `$${new Intl.NumberFormat().format(
                            value.value,
                          )}`;
                        },
                        arcLabel: getArcLabel,
                      },
                      {
                        arcLabelMinAngle: 5,
                        innerRadius: 160,
                        outerRadius: 250,
                        data: pieProductData,
                        arcLabel: getArcLabel,
                        valueFormatter: (value) => {
                          return `$${new Intl.NumberFormat().format(
                            value.value,
                          )}`;
                        },
                      },
                    ]}
                    sx={{
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: "white",
                        fontSize: 14,
                      },
                    }}
                    onItemClick={(event, d, item) => {
                      if (item.brandName) {
                        setSelectedBrand(item.brandName);
                        handlePieClick(item.brandName);
                      }
                    }}
                    height={700}
                  />
                ) : mode === "product" ? (
                  <PieChart
                    margin={{ right: 5 }}
                    colors={cheerfulFiestaPalette}
                    series={[
                      {
                        innerRadius: 0,
                        outerRadius: 250,
                        arcLabelMinAngle: 10,
                        data: pieProductData,
                        arcLabel: getArcLabel,
                        valueFormatter: (value) => {
                          return `$${new Intl.NumberFormat().format(
                            value.value,
                          )}`;
                        },
                      },
                    ]}
                    sx={{
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: "white",
                        fontSize: 14,
                      },
                    }}
                    height={700}
                  />
                ) : (
                  <BarChart
                    leftAxis={leftAxis}
                    margin={{ right: 5, left: 70 }}
                    series={chartData.series}
                    xAxis={[{ ...chartData.xAxis[0] }]}
                    height={chartData.height}
                    onAxisClick={async (event, d) => {
                      switch (mode) {
                        case "amPerformance":
                          const selectedAm = amOptions.find(
                            (amOption) => amOption.am_name === d.axisValue,
                          );
                          const filterOptions = _.filter(
                            allOptions,
                            (allOption) =>
                              selectedAm.am_id === allOption.user_id,
                          );

                          const filterDistrict = _.uniqBy(
                            _.map(
                              filterOptions.filter(
                                (option) => selectedAm.am_id === option.user_id,
                              ),
                              "district_id",
                            ),
                          );
                          const filterArea = areaOptions.filter((areaOption) =>
                            filterDistrict.includes(areaOption.district_id),
                          );

                          const updateFilter = {
                            ...filter,
                            district: filterDistrict,
                            am: [selectedAm.am_id],
                            area: _.map(filterArea, "area_id"),
                          };
                          setFilter(updateFilter);
                          setGroupBy("shop");
                          await fetchShopSales(updateFilter);
                          break;

                        case "all":
                          handleAxisClick(d.axisValue);
                          break;
                        case "shop":
                          setIsWholeMonth(false);
                          setSelectedDate(d.axisValue);
                          handleShopAxisClick(
                            d.axisValue,
                            d.axisValue,
                            "brand",
                          );
                          break;
                        default:
                          break;
                      }
                    }}
                    //slots={{ bar: limit === 0 ? null : CustomBar }}
                  />
                )}
              </Box>
            </Stack>
          </StyledPaper>
        </Fade>
      )}
    </Layout>
  );
};

export default ShopSalesChartPage;
